import { authApiCall } from '../../auth/saga';

export const getNewUsedCoupons = createdAfter =>
  authApiCall({
    url: `/coupons/check-used-coupons/`,
    method: 'get',
    params: { created_after: createdAfter },
  });
